import { postAsync } from "../httpServiceIntelafApi";
import { getAuthorization } from '../../../shared/TokenHeaders';

const URI = '/envio/MetodoEnvio';

export const postShowFlete = (flete) => {
    return postAsync(URI, getAuthorization(), flete);
}